import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';
import { useAuth } from '../auth';
import { BrandLogo } from '../components/BrandLogo';

export function LoginPage() {
  const { user } = useAuth();
  const client = useQueryClient();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const login = useMutation({
    mutationFn: () =>
      api('/api/v1/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
    onSuccess: () => void client.invalidateQueries({ queryKey: ['me'] }),
  });
  if (user) return <Navigate to="/" replace />;
  const submit = (event: FormEvent) => {
    event.preventDefault();
    login.mutate();
  };
  return (
    <main className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <BrandLogo />
        <div>
          <h1>Welcome back</h1>
          <p>Sign in to your support workspace.</p>
        </div>
        <label>
          Email
          <input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="current-password"
            minLength={12}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {login.error && (
          <p className="form-error" role="alert">
            {login.error.message}
          </p>
        )}
        <button className="primary" disabled={login.isPending}>
          {login.isPending ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </main>
  );
}
